/* ============================================================================
   GR-CART-SHEET 2026-10-06 (Claude). Pairs with assets/gr-cart-sheet.css.
   Owner: "the cart opens from the bottom like a iphone pop up like our notes", phones only.
   CartDrawer has no animation methods of its own (theme.js:4210-4225); it inherits Drawer's, which
   GR-POPUP-APPLE patches (gr-enhancements x-drawer). Defining them on CartDrawer.prototype shadows
   Drawer.prototype for <cart-drawer> ONLY. Below 700px it is the notes sheet; otherwise every call is handed to
   the inherited (GR-patched) method, so desktop is unchanged. The tier comes from CSS (--gr-cart-sheet):
   without the stylesheet the cart opens exactly as today.
   ROLLBACK: delete the GR-LVFEEL tags in sections/gr-enhancements.liquid.
   ========================================================================= */
(function () {
  'use strict';
  if (window.__grCartSheet) return;
  window.__grCartSheet = 1;

  var SHEET = 'cubic-bezier(.32,.72,0,1)';   /* notes + GR-POPUP-APPLE sheet rise */
  var VEIL  = 'cubic-bezier(.22,1,.36,1)';
  var OUTC  = 'cubic-bezier(.4,0,1,1)';
  var D_SHEET = 500, D_VEIL = 400, D_OUT = 300;
  var READY = 300;              /* the theme's drawer clock: focus trap + dialog:after-show (GR-POPUP-APPLE readyMs) */
  var DRAG_DISMISS = 0.28;      /* of sheet height */
  var FLICK = 0.75;             /* px/ms (GR-POPUP-APPLE) */
  var FLICK_MIN_TRAVEL = 24;    /* px */

  var sheetMq = window.matchMedia('screen and (max-width: 699.98px)');   /* identical to the CSS */
  var reduce  = window.matchMedia('(prefers-reduced-motion: reduce)');

  function part(el, n) { return el && el.shadowRoot ? el.shadowRoot.querySelector('[part="' + n + '"]') : null; }
  function cancelAll(el) { if (el) el.getAnimations().forEach(function (a) { try { a.cancel(); } catch (e) {} }); }
  function play(el, frames, d, easing) {
    if (!el) return null;
    try { cancelAll(el); return el.animate(frames, { duration: reduce.matches ? 1 : d, easing: easing, fill: 'both' }); }
    catch (e) { return null; }
  }
  /* the two-member object DialogElement expects (.finished / .finish()) */
  function controls(list, readyMs) {
    var a = list.filter(Boolean);
    var all = a.length
      ? Promise.all(a.map(function (x) { return x.finished.catch(function () {}); })).then(function () {})
      : Promise.resolve();
    return {
      finished: readyMs
        ? Promise.race([all, new Promise(function (r) { setTimeout(r, reduce.matches ? 0 : readyMs); })])
        : all,
      finish: function () { a.forEach(function (x) { try { x.finish(); } catch (e) {} }); }
    };
  }
  function cssSheet(host) {
    if (!sheetMq.matches) return false;
    try { return getComputedStyle(host).getPropertyValue('--gr-cart-sheet').trim() === '1'; } catch (e) { return false; }
  }
  function clearInline(host) {
    var c = part(host, 'content'), o = part(host, 'overlay');
    if (c) c.style.removeProperty('transform');
    if (o) o.style.removeProperty('opacity');
  }
  function ensureGrabber(host) {
    var c = part(host, 'content');
    if (!c || c.querySelector(':scope > [part="gr-grabber"]')) return;
    var pill = document.createElement('div');
    pill.setAttribute('part', 'gr-grabber');
    pill.setAttribute('aria-hidden', 'true');
    pill.style.position = 'absolute';   /* never a row of the desktop drawer grid, even if the CSS is missing */
    c.insertBefore(pill, c.firstChild);
  }

  /* ---------------- drag down to dismiss (cart only) ----------------
     Same rules as the notes / GR-POPUP-APPLE sheets, with ONE structural difference: in a drawer the scroller
     is ::part(body), not ::part(content). So the "at the top?" test reads the body, and only when the touch
     started inside it. Header, grabber and footer touches have nothing to scroll and engage on the first
     downward move. A moved touch never produces a click, so a drag can never press Checkout. */
  var drag = null, dragGen = 0;

  function inSideScroller(path, stop) {          /* e.g. a cross-sell scroll-carousel (.scroll-area) */
    for (var i = 0; i < path.length && path[i] !== stop; i++) {
      var n = path[i];
      if (!n || n.nodeType !== 1) continue;
      if (n.scrollWidth > n.clientWidth + 1) {
        var ox = getComputedStyle(n).overflowX;
        if (ox === 'auto' || ox === 'scroll') return true;
      }
    }
    return false;
  }

  function onStart(e) {
    var content = e.currentTarget, host = content.__grCartHost;
    if (drag) { if (drag.active) settle(drag, false); else drag = null; return; }   /* second finger: settle, never strand */
    if (!host || !host.__grCartIsSheet || !host.hasAttribute('open') || !sheetMq.matches) return;
    if (host.__grCartOut || e.touches.length !== 1) return;                         /* already sliding out */
    if (host.querySelector('cart-note-dialog[open]')) return;                       /* the note panel owns the sheet */
    var t = e.target;
    if (t && t.closest && t.closest('input, textarea, select, [contenteditable]')) return;
    var body = part(host, 'body');
    var path = e.composedPath ? e.composedPath() : [];
    var inBody = !!body && path.indexOf(body) !== -1;
    var p = e.touches[0];
    drag = {
      host: host, content: content, overlay: part(host, 'overlay'),
      t: e.target,                       /* the touched node: a cart re-render detaches it and its touch events stop */
      scroller: inBody ? body : null,
      side: inBody && inSideScroller(path, body),
      x0: p.clientX, y0: p.clientY, dy: 0, active: false,
      h: content.getBoundingClientRect().height || 1,
      moves: [], gen: ++dragGen
    };
  }

  function onMove(e) {
    var d = drag;
    if (!d || e.touches.length !== 1) return;
    var p = e.touches[0], dy = p.clientY - d.y0, dx = p.clientX - d.x0;
    if (!d.active) {
      if (dy < 0 || (d.scroller && d.scroller.scrollTop > 0)) { drag = null; return; }   /* a scroll, not a dismiss */
      if (!e.cancelable) { drag = null; return; }                                         /* the browser already owns it */
      if (dy === 0 || dy <= (d.side ? 2 : 1) * Math.abs(dx)) return;                      /* not vertical enough yet */
      d.active = true;
      cancelAll(d.content);   /* drop the enter fill; inline !important takes over below */
      cancelAll(d.overlay);
    }
    e.preventDefault();
    d.dy = Math.max(0, dy);
    d.moves.push({ y: p.clientY, t: e.timeStamp });
    if (d.moves.length > 12) d.moves.shift();
    d.content.style.setProperty('transform', 'translateY(' + d.dy + 'px)', 'important');
    if (d.overlay) d.overlay.style.setProperty('opacity', String(Math.max(0, 1 - d.dy / d.h)), 'important');
  }

  function velocity(d, endT) {
    var recent = d.moves.filter(function (m) { return endT - m.t <= 90; });   /* a parked finger is not a flick */
    if (recent.length < 2) return 0;
    var a = recent[0], b = recent[recent.length - 1];
    return (b.t - a.t) > 0 ? (b.y - a.y) / (b.t - a.t) : 0;
  }

  function settle(d, dismiss) {
    var host = d.host, content = d.content, overlay = d.overlay, gen = d.gen;
    drag = null;
    var fromY = d.dy, fromO = overlay ? (overlay.style.opacity || '1') : '1';
    clearInline(host);   /* drop the !important inline values BEFORE animating: they outrank animations */
    var dur = reduce.matches ? 1 : (dismiss ? D_OUT : D_SHEET);
    if (overlay) overlay.animate({ opacity: [fromO, dismiss ? 0 : 1] },
      { duration: dur, easing: dismiss ? 'ease' : VEIL, fill: 'both' }).finished.catch(function () {});
    if (!dismiss) {
      content.animate({ transform: ['translateY(' + fromY + 'px)', 'translateY(0px)'] },
        { duration: dur, easing: SHEET, fill: 'both' })
        .finished.catch(function () {}).then(function () {
          if (gen !== dragGen || !host.hasAttribute('open')) return;   /* newer gesture or closing: hands off */
          cancelAll(content); cancelAll(overlay);
        });
      return;
    }
    var out = content.animate({ transform: ['translateY(' + fromY + 'px)', 'translateY(100%)'] },
      { duration: dur, easing: OUTC, fill: 'both' });
    host.__grCartOut = out;   /* a hide() during the slide waits on it instead of replaying from 0 */
    out.finished.catch(function () {}).then(function () {
      host.__grCartOut = null;
      if (!host.hasAttribute('open')) return;                         /* an overlay tap already closed it */
      host.__grCartSkipLeave = 1;                                      /* only unwind focus trap + lock */
      try { host.hide(); } catch (e) {}
    });
  }

  function onEnd(e) {
    var d = drag;
    if (!d) return;
    if (!d.active) { drag = null; return; }
    var v = velocity(d, e.timeStamp);
    settle(d, d.dy > d.h * DRAG_DISMISS || (v > FLICK && d.dy > FLICK_MIN_TRAVEL));
  }
  function onCancel() {             /* the OS took the gesture: always snap back */
    var d = drag;
    if (!d) return;
    if (d.active) settle(d, false); else drag = null;
  }
  function bind(host) {             /* scoped to the panel; bound on the first sheet-tier open only */
    var c = part(host, 'content');
    if (!c || c.__grCartHost) return;
    c.__grCartHost = host;
    c.addEventListener('touchstart', onStart, { passive: true });
    c.addEventListener('touchmove', onMove, { passive: false });
    c.addEventListener('touchend', onEnd, { passive: true });
    c.addEventListener('touchcancel', onCancel, { passive: true });
    /* + / Remove re-render the cart (replaceChildren) — if that detached the node under the finger mid-swipe, its
       touchmove/touchend never reach us again: snap the sheet back instead of leaving it frozen half-way */
    host.addEventListener('cart-drawer:refreshed', function () {
      var d = drag;
      if (!d || d.host !== host || !d.t || d.t.isConnected) return;
      if (d.active) settle(d, false); else drag = null;
    });
  }

  /* ---------------- the motion ---------------- */
  window.customElements.whenDefined('cart-drawer').then(function (Klass) {
    var P = Klass.prototype;
    if (Object.prototype.hasOwnProperty.call(P, 'createEnterAnimationControls')) return;   /* theme changed: stand down */
    var Base = Object.getPrototypeOf(P);   /* Drawer.prototype, carrying the GR-POPUP-APPLE x-drawer patch */

    P.createEnterAnimationControls = function () {
      var host = this;
      if (drag && drag.host === host) { dragGen++; drag = null; }
      host.__grCartOut = null;
      host.__grCartSkipLeave = 0;
      clearInline(host);                                     /* a reopen never starts where a drag left it */
      cancelAll(part(host, 'content'));                      /* no stale sheet fill can outlive a tier switch */
      cancelAll(part(host, 'overlay'));
      host.__grCartIsSheet = cssSheet(host);
      if (!host.__grCartIsSheet) return Base.createEnterAnimationControls.call(host);
      try {
        ensureGrabber(host);
        bind(host);
        var c = part(host, 'content');
        /* the theme's own edge pin (theme.js:2014): a no-op at full width, kept so a rotation to >=700px while open lands right */
        if (c) c.style.marginInlineStart = (host.getAttribute('open-from') || 'right') === 'right' ? 'auto' : '0';
        return controls([
          play(part(host, 'overlay'), { opacity: [0, 1] }, D_VEIL, VEIL),
          play(c, { transform: ['translateY(100%)', 'translateY(0)'] }, D_SHEET, SHEET)
        ], READY);
      } catch (e) {
        host.__grCartIsSheet = false;
        return Base.createEnterAnimationControls.call(host);
      }
    };

    P.createLeaveAnimationControls = function () {
      var host = this;
      if (host.__grCartSkipLeave) { host.__grCartSkipLeave = 0; return controls([]); }
      if (host.__grCartOut) return controls([host.__grCartOut]);
      if (drag && drag.host === host) { dragGen++; drag = null; }
      clearInline(host);
      if (!cssSheet(host)) return Base.createLeaveAnimationControls.call(host);
      try {
        return controls([
          play(part(host, 'overlay'), { opacity: [1, 0] }, D_OUT, VEIL),
          play(part(host, 'content'), { transform: ['translateY(0)', 'translateY(100%)'] }, D_OUT, OUTC)
        ]);
      } catch (e) { return Base.createLeaveAnimationControls.call(host); }
    };
  }).catch(function () {});
})();
